var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.955 0.849609L23.7046 0.824685C23.6908 0.410701 23.344 0.0862595 22.93 0.100024L22.955 0.849609ZM9.58427 14.0417C9.30126 14.3442 9.31704 14.8188 9.61949 15.1018C9.92195 15.3848 10.3966 15.369 10.6796 15.0666L9.58427 14.0417ZM22.4014 6.76944C22.4152 7.18342 22.7619 7.50786 23.1759 7.4941C23.5899 7.48033 23.9143 7.13357 23.9006 6.71959L22.4014 6.76944ZM17.0349 0.296024C16.6209 0.309788 16.2965 0.656547 16.3102 1.07053C16.324 1.48452 16.6708 1.80896 17.0847 1.7952L17.0349 0.296024ZM11.2813 2.1553V1.4053H3V2.1553V2.9053H11.2813V2.1553ZM1 4.1553H0.25V21.2728H1H1.75V4.1553H1ZM3 23.2728V24.0228H19.8405V23.2728V22.5228H3V23.2728ZM21.8405 21.2728H22.5905V12.7141H21.8405H21.0905V21.2728H21.8405ZM19.8405 23.2728V24.0228C21.3593 24.0228 22.5905 22.7916 22.5905 21.2728H21.8405H21.0905C21.0905 21.9632 20.5309 22.5228 19.8405 22.5228V23.2728ZM1 21.2728H0.25C0.25 22.7916 1.48122 24.0228 3 24.0228V23.2728V22.5228C2.30964 22.5228 1.75 21.9632 1.75 21.2728H1ZM3 2.1553V1.4053C1.48122 1.4053 0.25 2.63652 0.25 4.1553H1H1.75C1.75 3.46495 2.30965 2.9053 3 2.9053V2.1553ZM22.955 0.849609L22.4073 0.337185L9.58427 14.0417L10.1319 14.5541L10.6796 15.0666L23.5026 1.36203L22.955 0.849609ZM22.955 0.849609L22.2054 0.874533L22.4014 6.76944L23.151 6.74451L23.9006 6.71959L23.7046 0.824685L22.955 0.849609ZM22.955 0.849609L22.93 0.100024L17.0349 0.296024L17.0598 1.04561L17.0847 1.7952L22.9799 1.5992L22.955 0.849609Z",
    fill: "url(#paint0_linear_6683_1982)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6683_1982",
    x1: 12,
    y1: -1.5,
    x2: 12.0755,
    y2: 23.2728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIc);
export default __webpack_public_path__ + "static/media/share-ic.a5426c60c2abb3f6f819b0ed32b9ff3b.svg";
export { ForwardRef as ReactComponent };